import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./login.scss";
import logo from "../../assets/logo/kalkiAiLogo.png";
import { Form, Formik } from "formik";
import { useAppSelector } from "../../redux-toolkit/hooks";
import { getAllUserGroupDetails, setAllUserGroup } from "../../redux-toolkit/slices/allUserGroupSlice";
import { getAllUserRoleDetails, setAllUserRole } from "../../redux-toolkit/slices/allUserRoleSlice";
import { getAllcountryDetail, setcountry } from "../../redux-toolkit/slices/countrySlice";
import { getFindStateByCountryNameDetail, setStates } from "../../redux-toolkit/slices/statesSlice";
import { useSaveUserMutation } from "../../redux-toolkit/services/allUserService";
import { useGetAllUserGroupMutation } from "../../redux-toolkit/services/userGroupService";
import { useGetAllUserRoleMutation } from "../../redux-toolkit/services/userRoleService";
import { useGetAllCountryMutation } from "../../redux-toolkit/services/countryService";
import { useGetStateMutation } from "../../redux-toolkit/services/stateService";
import { alertMessage } from "../../utils/AlertService";
import { useDispatch } from "react-redux";
import Loading from "../../components/Loading";
import * as Yup from "yup";
import { setAllUser } from "../../redux-toolkit/slices/allUserSlice";
import Header from "../Header/Header";

type Props = {};


const Signup = (props: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //states
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [selectedCountry, setSelectedCountry]: any = useState();
  const [name, setName]: any = useState();
  const [address, setAddress]: any = useState();
  const [orgName, setOrgName]: any = useState();

  //Mutation
  const [signUpUser, signUpResponse] = useSaveUserMutation();
  const [getAllUserGroup, allUserGroupResponse] = useGetAllUserGroupMutation();
  const [getAllUserRole, allUserRoleResponse] = useGetAllUserRoleMutation();
  const [getCountry, getCountryResponse] = useGetAllCountryMutation();
  const [getState, getStateResponse] = useGetStateMutation();

  // get All Mutation
  // const [getAllPackages, getAllPackagesResponse] = useGetAllPackagesMutation();

  // selector
  const allUserGroup: any = useAppSelector(getAllUserGroupDetails);
  const allUserRole: any = useAppSelector(getAllUserRoleDetails);
  const allCountries: any = useAppSelector(getAllcountryDetail);
  // const allCities: any = useAppSelector(getFindCityByStateIdDetail);
  const allStates: any = useAppSelector(getFindStateByCountryNameDetail);
  // const getAllPackagesList: any = useAppSelector(getPackageMasterList)

  const SignupSchema = Yup.object().shape({
    firstName: Yup.string().required("Please enter First name!"),
    lastName: Yup.string().required("Please enter Last name!"),
    phoneNumber: Yup.string()
      .required("Please enter phone Number!")
      .matches(
        /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/,
        "Phone number is not valid"
      )
      .min(10, "Contact Number must be 10 digits")
      .max(10, "Contact Number must be 10 digits")
      .trim(),

    email: Yup.string()
      .email("Invalid email format")
      .required("Please enter Email Address!"),

    // selectedPackage: Yup.string().when("role", (role, schema) => {
    //   const roleId = Array.isArray(role) ? role[0] : role;
    //   const roleObj = allUserRole?.find((r: any) => r.id == roleId);
    //   const isAdmin = roleObj?.name === "Admin";
    //   return isAdmin
    //     ? schema.notRequired()
    //     : schema.required("Please select package to proceed!");
    // }),
    // pricingType: Yup.string().when("role", (role, schema) => {
    //   const roleId = Array.isArray(role) ? role[0] : role;
    //   const roleObj = allUserRole?.find((r: any) => r.id == roleId);
    //   const isAdmin = roleObj?.name === "Admin";
    //   return isAdmin
    //     ? schema.notRequired()
    //     : schema.required("Please select pricing type!");
    // }),

    group: Yup.string().required("Please select group"),
    role: Yup.string().required("Please select role"),

    termsAndConditionsCheckbox: Yup.boolean()
      .oneOf([true], "Please agree to the Terms and Conditions")
      .required(),

    privacyPolicyCheckbox: Yup.boolean()
      .oneOf([true], "Please agree to the Privacy Policy")
      .required(),
  });


  const pricingTypes = [
    { label: "Monthly", value: "monthly" },
    { label: "Yearly", value: "yearly" }
  ];


  useEffect(() => {
    getCountry({});
    getAllUserGroup({});
    getAllUserRole({});
    // getAllPackages({});
  }, []);

  // useEffect(() => {
  //   if (getAllPackagesResponse.isSuccess) {
  //     dispatch(setAllPackageMasterList(getAllPackagesResponse));
  //   }
  //   else if (getAllPackagesResponse.isError) {
  //     alertMessage("Error while fetching packages", "error");
  //   }

  // }, [getAllPackagesResponse.isSuccess, getAllPackagesResponse.isError]);

  const handleSelectCountry = (event: any) => {
    setSelectedCountry(event.target.value);
    if (event) {
      getState({
        countryId: event.target.value,
      });
    }
  };

  const handleSubmit = (values: any) => {
    const payload = {
      address: values.address,
      // briefProfile: values.briefProfile,
      cityId: values.city,
      countryId: parseInt(selectedCountry), //values.country,
      email: values.email,
      firstName: values.firstName,
      // id: 0,
      lastName: values.lastName,
      linkedinRef: values.linkedinRef,
      organizationName: values.organizationName,
      password: values.email,
      phoneNumber: values.phoneNumber,
      postalCode: values.pinCode,
      stateId: parseInt(values.state),
      userGroupId: parseInt(values.group),
      userRoleId: parseInt(values.role),
      roleIds: [parseInt(values.role)],
      username: values.email,
      termsAndCondition: values.termsAndConditionsCheckbox,
      privacyPolicy: values.privacyPolicyCheckbox,
      // packageId: parseInt(values.selectedPackage),
      isUserSubscribed: true,
      // packageType: values.pricingType
    }

    signUpUser({
      payload: payload
    })
  };

  useEffect(() => {
    if (getCountryResponse.isSuccess) {
      dispatch(setcountry(getCountryResponse));
    } else if (getCountryResponse.isError) {
      alertMessage("Error while fetching countries", "error");
    }
  }, [getCountryResponse.isSuccess, getCountryResponse.isError]);

  useEffect(() => {
    if (getStateResponse.isSuccess) {
      dispatch(setStates(getStateResponse));
    } else if (getStateResponse.isError) {
      alertMessage("Error while fetchin states", "error");
    }
  }, [getStateResponse.isSuccess, getStateResponse.isError]);

  useEffect(() => {
    if (allUserGroupResponse.isSuccess) {
      dispatch(setAllUserGroup(allUserGroupResponse));

    } else if (allUserGroupResponse.isError) {
      alertMessage("Error while fetching User group", "error");
    }
  }, [allUserGroupResponse.isSuccess, allUserGroupResponse.isError]);

  useEffect(() => {
    if (allUserRoleResponse.isSuccess) {
      dispatch(setAllUserRole(allUserRoleResponse));

    } else if (allUserRoleResponse.isError) {
      alertMessage("Error while fetching User role", "error");
    }
  }, [allUserRoleResponse.isSuccess, allUserRoleResponse.isError]);

  useEffect(() => {
    if (signUpResponse.isSuccess) {
      dispatch(setAllUser(signUpResponse));
      alertMessage("Your account has been successfully created", "success");
      // alertMessage("An email sent to given email address for verification, please verify for account activation", "success")
      navigate("/login", { replace: true });

    } else if (signUpResponse.isError) {
      let response: any = signUpResponse?.error;
      alertMessage(response.data.serviceErrors[0].msg ? response.data.serviceErrors[0].msg : "Error while creating account", "error");
    }
  }, [signUpResponse.isSuccess, signUpResponse.isError])


  return (
    <>
      <Header />
      <div className="px-3 px-md-5 pb-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-8 login-box">
              <h2 className="text-xl fw-bold mb-3 text-center mt-3">Sign Up</h2>

              {signUpResponse.isLoading ? <Loading /> : ""}

              <Formik
                initialValues={{
                  firstName: "", lastName: "", email: "", phoneNumber: "", state: "", city: "",
                  country: "", password: "", pinCode: "", linkedinRef: "", organizationName: "",
                  // briefProfile: "",
                  address: "", group: "", role: "",
                  termsAndConditionsCheckbox: false,
                  privacyPolicyCheckbox: false,
                  // selectedPackage: "",
                  // pricingType: "",
                }}
                validationSchema={SignupSchema}
                onSubmit={handleSubmit}
              >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <div className="row gy-3">
                      {/* Left Column */}
                      <div className="col-lg-6 col-md-12">
                        <div className="mb-3">
                          <input
                            type="text"
                            value={values.firstName}
                            name="firstName"
                            onChange={(e) => {
                              handleChange(e)
                              setName(e.target.value)
                            }}
                            className={`form-control form-textbox bg-secondary-light border-secondary-light ${errors.firstName ? 'is-invalid' : ''}`}
                            id="firstName"
                            aria-describedby="firstName"
                            placeholder="First Name"
                          />
                          {touched.firstName && typeof errors.firstName === 'string' && (
                            <div className="text-danger">{errors.firstName}</div>
                          )}
                        </div>
                        <div className="mb-3">
                          <input
                            type="email"
                            value={values.email}
                            name="email"
                            onChange={handleChange}
                            className={`form-control form-textbox bg-secondary-light border-secondary-light ${errors.email ? 'is-invalid' : ''}`}
                            id="email"
                            aria-describedby="email"
                            placeholder="Email"
                          />
                          {touched.email && typeof errors.email === 'string' && (
                            <div className="text-danger">{errors.email}</div>
                          )}
                        </div>
                        {/* <div className="mb-3">
                              <input
                                type="text"
                                value={values.organizationName}
                                name="organizationName"
                                onChange={(e) => {
                                  handleChange(e)
                                  setAddress(e.target.value)
                                }}
                                className={`form-control form-textbox bg-secondary-light border-secondary-light ${errors.organizationName ? 'is-invalid' : ''}`}
                                id="organizationName"
                                aria-describedby="organizationName"
                                placeholder="Organization Name"
                              />
                            </div> */}
                        <div className="mb-3">
                          <select
                            className={`form-select form-textbox ${errors.group ? 'is-invalid' : ''}`}
                            aria-label="selectColumn"
                            onChange={handleChange}
                            aria-placeholder="Group"
                            value={values.group}
                            name="group"
                          >
                            <option>Group</option>
                            {allUserGroup && allUserGroup.map((userGroup: any, index: any) => {
                              return (
                                <option key={index} value={userGroup.id}>
                                  {userGroup.name}
                                </option>
                              );
                            })}
                          </select>
                          {touched.group && typeof errors.group === 'string' && (
                            <div className="text-danger">{errors.group}</div>
                          )}
                        </div>
                        <div className="mb-3">
                          <input
                            type="text"
                            value={values.address}
                            name="address"
                            onChange={(e) => {
                              handleChange(e)
                              // setOrgName(e.target.value)
                            }}
                            className={`form-control form-textbox bg-secondary-light border-secondary-light ${errors.address ? 'is-invalid' : ''}`}
                            id="address"
                            aria-describedby="address"
                            placeholder="Address"
                          />
                        </div>
                        <div className="mb-3">
                          <select
                            className="form-select form-textbox"
                            // ${errors.country ? 'is-invalid' : ''}
                            aria-label="selectColumn"
                            onChange={handleSelectCountry}
                            aria-placeholder="Country"
                            name="country"
                            value={selectedCountry}
                          >
                            <option>Country</option>
                            {allCountries && allCountries.map((country: any, index: any) => {
                              return (
                                <option key={index} value={country.id}>
                                  {country.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <div className="mb-3">
                          <select
                            className="form-select form-textbox bg-secondary-light border-secondary-light"
                            // ${errors.state ? 'is-invalid' : ''}
                            aria-label="selectColumn"
                            onChange={handleChange}
                            aria-placeholder="State"
                            name="state"
                            value={values.state}
                          >
                            <option>State</option>
                            {allStates && allStates.map((state: any, index: any) => {
                              return (
                                <option key={index} value={state.id}>
                                  {state.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        {/* {(() => {
                              const selectedRoleId = Array.isArray(values.role) ? values.role[0] : values.role;
                              const selectedRole = allUserRole?.find((role: any) => role.id == selectedRoleId);

                              if (selectedRole?.name === "Admin") return null;

                              return (
                                <div className="mb-3">
                                  <select
                                    className={`form-select form-textbox ${errors.selectedPackage ? 'is-invalid' : ''}`}
                                    aria-label="selectColumn"
                                    onChange={handleChange}
                                    name="selectedPackage"
                                    value={values.selectedPackage}
                                  >
                                    <option value="">Pricing Plan</option>
                                    {getAllPackagesList && getAllPackagesList.map((selectedPackage: any, index: any) => (
                                      <option key={index} value={selectedPackage.id}>
                                        {selectedPackage.name}
                                      </option>
                                    ))}
                                  </select>
                                  {touched.selectedPackage && typeof errors.selectedPackage === 'string' && (
                                    <div className="text-danger">{errors.selectedPackage}</div>
                                  )}
                                </div>
                              );
                            })()} */}

                      </div>

                      {/* Right Column */}
                      <div className="col-lg-6 col-md-12">
                        <div className="mb-3">
                          <input
                            type="text"
                            value={values.lastName}
                            name="lastName"
                            onChange={handleChange}
                            className={`form-control form-textbox bg-secondary-light border-secondary-light ${errors.lastName ? 'is-invalid' : ''}`}
                            id="lastName"
                            aria-describedby="lastName"
                            placeholder="Last Name"
                          />
                          {touched.lastName && typeof errors.lastName === 'string' && (
                            <div className="text-danger">{errors.lastName}</div>
                          )}
                        </div>
                        <div className="mb-3">
                          <input
                            type="text"
                            value={values.phoneNumber}
                            name="phoneNumber"
                            onChange={handleChange}
                            className={`form-control form-textbox bg-secondary-light border-secondary-light ${errors.phoneNumber ? 'is-invalid' : ''}`}
                            id="phoneNumber"
                            aria-describedby="phoneNumber"
                            placeholder="Mobile Number"
                          />
                          {touched.phoneNumber && typeof errors.phoneNumber === 'string' && (
                            <div className="text-danger">{errors.phoneNumber}</div>
                          )}
                        </div>
                        <div className="mb-3">
                          <input
                            type="text"
                            value={values.linkedinRef}
                            name="linkedinRef"
                            onChange={handleChange}
                            className={`form-control form-textbox bg-secondary-light border-secondary-light ${errors.linkedinRef ? 'is-invalid' : ''}`}
                            id="linkedinRef"
                            aria-describedby="linkedinRef"
                            placeholder="Linkedin Ref"
                          />
                        </div>
                        <div className="mb-3">
                          {/* <input
                                className="form-control form-textbox bg-secondary-light border-secondary-light"
                                aria-label=".form-control-sm example"
                                onChange={handleChange}
                                value={values.role}
                                name="role"
                                placeholder="Beta Test User"
                                disabled
                              /> */}
                          <select
                            className={`form-select form-textbox ${errors.role ? 'is-invalid' : ''}`}
                            aria-label="selectColumn"
                            onChange={handleChange}
                            aria-placeholder="Role"
                            value={values.role}
                            name="role"
                          >
                            <option>Role</option>
                            {allUserRole && allUserRole.map((role: any, index: any) => {
                              return (
                                <option key={index} value={role.id}>
                                  {role.name}
                                </option>
                              );
                            })}
                          </select>
                          {touched.role && typeof errors.role === 'string' && (
                            <div className="text-danger">{errors.role}</div>
                          )}
                        </div>
                        {/* <div className="mb-3">
                              <select
                                className={`form-select form-textbox ${errors.selectedPackage ? 'is-invalid' : ''}`}
                                aria-label="selectColumn"
                                onChange={handleChange}
                                aria-placeholder="Package"
                                value={values.selectedPackage}
                                name="selectedPackage"
                              >
                                <option>Pricing Plan</option>
                                {allPackagesData && allPackagesData.map((packageDetail: any, index: any) => {
                                  return (
                                    <option key={index} value={packageDetail.id}>
                                      {packageDetail.name}
                                    </option>
                                  );
                                })}
                              </select>
                            </div> */}
                        <div className="mb-3">
                          <input
                            className="form-control form-textbox"
                            type="text"
                            aria-label=".form-control-sm example"
                            onChange={handleChange}
                            value={values.city}
                            name="city"
                            placeholder="City"
                          />
                        </div>
                        <div className="mb-3">
                          <input
                            type="text"
                            value={values.pinCode}
                            name="pinCode"
                            onChange={handleChange}
                            className={`form-control form-textbox bg-secondary-light border-secondary-light ${errors.pinCode ? 'is-invalid' : ''}`}
                            id="pinCode"
                            aria-describedby="pinCode"
                            placeholder="Remark"
                          />
                        </div>
                        {/* {(() => {
                              const selectedRoleId = Array.isArray(values.role) ? values.role[0] : values.role;
                              const selectedRole = allUserRole?.find((role: any) => role.id == selectedRoleId);

                              if (selectedRole?.name === "Admin") return null;

                              return (
                                <div className="mb-3">
                                  <select
                                    className={`form-select form-textbox ${errors.pricingType ? 'is-invalid' : ''}`}
                                    aria-label="selectPricingType"
                                    onChange={handleChange}
                                    name="pricingType"
                                    value={values.pricingType}
                                  >
                                    <option value="">Pricing Type</option>
                                    {pricingTypes.map((type: any, index: any) => (
                                      <option key={index} value={type.value}>
                                        {type.label}
                                      </option>
                                    ))}
                                  </select>
                                  {touched.pricingType && typeof errors.pricingType === 'string' && (
                                    <div className="text-danger">{errors.pricingType}</div>
                                  )}
                                </div>
                              );
                            })()} */}
                      </div>
                    </div>

                    {/* Checkboxes */}
                    <div className="mt-3">
                      <div className="form-check d-flex align-items-center gap-2 mb-2">
                        <input
                          type="checkbox"
                          id="termsAndConditionsCheckbox"
                          name="termsAndConditionsCheckbox"
                          checked={values.termsAndConditionsCheckbox}
                          onChange={handleChange}
                          className={`form-check-input m-0 ${errors.termsAndConditionsCheckbox && touched.termsAndConditionsCheckbox ? 'is-invalid' : ''}`}
                        />
                        <label htmlFor="termsAndConditionsCheckbox" className="form-check-label text-secondary mb-0">
                          I agree to the{" "}
                          <Link to="" className="text-accent" target="_blank" onClick={() => localStorage.setItem("routeTo", "terms-and-conditions")}>
                            Terms and Conditions
                          </Link>.
                        </label>
                      </div>
                      {errors.termsAndConditionsCheckbox && touched.termsAndConditionsCheckbox && (
                        <div className="text-danger">{errors.termsAndConditionsCheckbox}</div>
                      )}

                      <div className="form-check d-flex align-items-center gap-2 mb-2">
                        <input
                          type="checkbox"
                          id="privacyPolicyCheckbox"
                          name="privacyPolicyCheckbox"
                          checked={values.privacyPolicyCheckbox}
                          onChange={handleChange}
                          className={`form-check-input m-0 ${errors.privacyPolicyCheckbox && touched.privacyPolicyCheckbox ? 'is-invalid' : ''}`}
                        />
                        <label htmlFor="privacyPolicyCheckbox" className="form-check-label text-secondary mb-0">
                          I have read and agree to the{" "}
                          <Link to="" className="text-accent" target="_blank" onClick={() => localStorage.setItem("routeTo", "privacy-policy")}>
                            Privacy Policy
                          </Link>.
                        </label>
                      </div>
                      {errors.privacyPolicyCheckbox && touched.privacyPolicyCheckbox && (
                        <div className="text-danger">{errors.privacyPolicyCheckbox}</div>
                      )}
                    </div>

                    {/* Submit Button */}
                    <div className="d-grid gap-2 mt-4">
                      <button type="submit" className="btn btn-success">
                        Sign Up
                      </button>
                    </div>

                    <p className="mt-3 text-center">
                      Already have an account?{" "}
                      <Link to="/login" className="text-accent">
                        Click here to login
                      </Link>
                    </p>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}

export default Signup;
